import { Box, BoxProps, Button, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState, StatusPill, TalonCard } from '..';
import { useProjectStore, useTalentManagerStore } from '../../../context';

export type TalentManagerPanelProps = {
  cardProps?: BoxProps;
  headerBackground?: string;
};

export const TalentManagerPanel = observer(({ cardProps, headerBackground }: TalentManagerPanelProps) => {
  const navigate = useNavigate();
  const tmStore = useTalentManagerStore();
  const projectStore = useProjectStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    tmStore.fetchGroupEngagements().then(() => setLoading(false));
  }, []);

  const engagements = tmStore.groupEngagements.filter((e) => e.project_id === projectStore.currentProject?.id);

  return (
    <TalonCard
      label="Talent Managers"
      cardProps={cardProps}
      headerBackground={headerBackground}
      hideFooter
      isLoading={loading}
    >
      {engagements.length === 0 ? (
        <EmptyState title="No talent manager engaged" body="Find one in the Marketplace.">
          <Button secondary size="small" label="Open Marketplace" onClick={() => navigate('/marketplace')} />
        </EmptyState>
      ) : (
        engagements.map((e) => (
          <Box key={e.id} pad="small" border={{ side: 'bottom', color: 'light-3' }}>
            <Text weight="bold" size="small">
              {e.talentManagerProfile?.user?.first_name} {e.talentManagerProfile?.user?.last_name}
            </Text>
            <StatusPill label={e.status} tone={e.status === 'active' ? 'ok' : 'neutral'} />
          </Box>
        ))
      )}
    </TalonCard>
  );
});
